import { Form, Tooltip } from "antd";
import React, { memo } from "react";
import { ImageDisplay } from "./imageDisplay";
import { xmlProps } from "../../constants";

const QaDataDisplay = ({ label, itemData, renderContext, numbersOfColumnsToRender, record }) => {
    if (renderContext === "header" && itemData?.key === "actividade") {
        itemData["@etiqueta"] = "Tarefa";
    }

    if ((itemData?.isColumn === true && renderContext !== "inputGroup") || !itemData?.["@etiqueta"]) {
        if (typeof itemData?.value === "number") {
            return itemData?.value;
        } else if (itemData.value) {
            if (itemData.value.length > 30 && numbersOfColumnsToRender > 3) {
                return (
                    <Tooltip title={itemData.value}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {itemData[xmlProps.imagem] && (
                                <ImageDisplay
                                    itemData={{
                                        [xmlProps.imagem]: itemData[xmlProps.imagem],
                                        value: record[itemData["@imagem_key"]],
                                    }}
                                    showAvatar
                                />
                            )}
                            <div
                                style={{
                                    textOverflow: "ellipsis",
                                    // width: " 250px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                }}
                            >
                                {itemData.value}
                            </div>
                        </div>
                    </Tooltip>
                );
            } else {
                return (
                    <>
                        {itemData[xmlProps.imagem] && (
                            <ImageDisplay
                                itemData={{
                                    [xmlProps.imagem]: itemData[xmlProps.imagem],
                                    value: record[itemData["@imagem_key"]],
                                }}
                                showAvatar
                            />
                        )}
                        {itemData.value}
                    </>
                );
            }
        }
        return null;
    } else {
        if (typeof itemData?.value !== "number" && itemData?.value?.includes("\n")) {
            const htmlText = String(
                typeof itemData?.value === "object" ? itemData?.value[0]?.[itemData.key] : itemData?.value
            ).replace(/<br>/gi, "\n");

            return (
                <Form.Item label={label}>
                    <pre>{htmlText}</pre>
                </Form.Item>
            );
        }

        return (
            <Form.Item label={label}>
                {typeof itemData?.value === "object" ? itemData?.value?.[0]?.[itemData.key] : itemData?.value}
            </Form.Item>
        );
    }
};

const compareProps = (prevProps, nextProps) => {
    if (
        prevProps.itemData.value &&
        prevProps.itemData.key === "idade_atual" &&
        prevProps.itemData["@persiste"] === "nao" &&
        !nextProps.itemData.value
    ) {
        return true;
    }

    return prevProps.itemData.value === nextProps.itemData.value;
};

export default memo(QaDataDisplay, compareProps);
